import head from 'ramda/src/head'
import last from 'ramda/src/last'
import has from 'ramda/src/has'
import path from 'ramda/src/path'

export default {

  data: () => ({
    errors: {
      _general: false
    }
  }),

  methods: {
    formValidator_clearErrors() {
      const setAllToFalse = object => {
        for (const key in object) {
          object[key] = false
        }
      }

      setAllToFalse(this.errors)
    },

    formValidator_displayError(err) {
      const amioError = path(['response', 'data'], err)
      if (!amioError) {
        this.errors['_general'] = err
        return
      }

      const error = head(amioError.errors)
      if (!error.field) {
        this.errors['_general'] = error.message
        return
      }

      const fieldParts = error.field.split('.')
      const field = head(fieldParts)

      if (has(field, this.errors)) {
        if (error.field.endsWith(']')) {
          const index = resolveIndex(fieldParts)
          this.errors[field] = {[index]: error.message}
          return
        }

        this.errors[field] = error.message
        return
      }

      this.errors['_general'] = error.message
    }
  }

}

/**
 * In loving memory of Karel, here is your comment ;)
 *
 * If we want to point an error that is from an array we need its index.
 * The field can have this form - domains_whitelist.[1] - then the index is 1.
 */
function resolveIndex(fieldParts) {
  return last(fieldParts)
    .replace('[', '')
    .replace(']', '')
}
